import {toAbsoluteUrl} from '../../../../_metronic/helpers'

function CreateLoading() {
  return <h1 className='fw-bolder text-dark mb-3'>Добавление...</h1>
}

export {CreateLoading}
